import {axiosBffFetch} from '../../axios/axiosBffFetch';
import type {PopupVo} from '../../common/shared/api/gateway/popup/PopupVo.interface';
import type {ApiResultVo} from '../../common/shared/api/nicolas/vo/ApiResultVo.interface';

/**
 * 팝업 정보 조회
 *
 * Origin: pageNicolasApi.getPopup
 * API: GET /api/v9/store/popup
 */
export async function getStorePopup(): Promise<
  ApiResultVo & {result: PopupVo}
> {
  const response = await axiosBffFetch('/api/gateway/api/v9/store/popup', {
    method: 'GET',
  });
  return response.data;
}
